module.exports = __webpack_public_path__ + "img/milady_logo.b211c323.svg";